import { Component, OnInit, NgZone } from '@angular/core';
import { ProductsService } from 'src/app/services';
import { NzNotificationService } from 'ng-zorro-antd';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {Router} from '@angular/router';

@Component({
  selector: 'app-products-history',
  templateUrl: './products-history.component.html',
  styleUrls: ['./products-history.component.scss'],
})
export class ProductsHistoryComponent implements OnInit {
  listProductHistory: any = [];
  total: any = 0;
  loading: any = false;
  page: any = 1;
  pageSize: any = 8;
  isVisibleCompare: any = false;
  productId: any = null;
  unsubscribe$ = new Subject<void>();
  imageFalse: any = [];
  compareDetail: any = null;
  newInfo: any = null;
  oldInfo: any = null;
  newCategories: any = null;
  oldCategories: any = null;

  constructor(
    private notification: NzNotificationService,
    private productService: ProductsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.productId = window.location.href.split('/')[5];
    this.getListProdHistory();
  }

  getListProdHistory() {
    const query = {
      page: this.page,
      page_size: this.pageSize,
      productId: this.productId,
    };
    this.loading = true;
    this.productService
      .getListHistory(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          if (res.code === 1) {
            if (res.data && res.data.items) {
              this.listProductHistory = [...res.data.items];
              this.total = res.data.totalElement;
            }
          } else {
            this.notification.warning(
              'Có lỗi xảy ra',
              res.message || 'Vui lòng thử lại'
            );
          }
          this.loading = false;
        },
        (error: any) => {
          this.notification.error(
            'Có lỗi xảy ra',
            error.message || 'Vui lòng thử lại'
          );
          this.loading = false;
        }
      );
  }

  getCompareDetail(id: any) {
    this.productService
      .getCompareDetail(id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        if (res.code === 1) {
          this.newInfo = Object.assign({}, res.data.newInfo);
          this.oldInfo = Object.assign({}, res.data.oldInfo);
          if (this.newInfo.categoriesList) {
            this.newInfo._categoriesList = this.newInfo.categoriesList.map((gg: any) => gg.name).join('/');
          }
          if (this.oldInfo.categoriesList) {
            this.oldInfo._categoriesList = this.oldInfo.categoriesList.map((gg: any) => gg.name).join('/');
          }
          this.newInfo.roleCode = res.data.roleCode;
          this.oldInfo.roleCode = res.data.roleCode;
          this.newInfo.managementStatus = res.data.managementStatus;
          this.oldInfo.managementStatus = res.data.managementStatus;
          this.newInfo.reason = res.data.reason;
          this.oldInfo.reason = res.data.reason;
          this.newInfo.requestInfoStatus = res.data.requestInfoStatus;
          this.oldInfo.requestInfoStatus = res.data.requestInfoStatus;
        }
      });
  }

  showModalCompare(item: any) {
    this.isVisibleCompare = true;
    this.getCompareDetail(item.id);
  }

  handleCancelCompare() {
    this.isVisibleCompare = false;
  }

  /*Check link image error*/
  checkImageErr(imageError) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink) {
    if (!this.imageFalse.includes(id)) {
      window.open(imageLink, '_blank');
    }
  }

  applyChange(item: any) {
    this.router.navigate(['business', 'products', this.productId ]);
    localStorage.setItem('history_item', JSON.stringify(item));
  }
}
